import { ITextStyle, TTextType } from './types'

export const TEXT_STYLES: Record<TTextType, ITextStyle> = {
  h1: { size: '16px', weight: '600' },
  h2: { size: '14px', weight: '500' },
  h3: { size: '12px', weight: '700' },
  h4: { size: '12px', weight: '500' },
  h5: { size: '11px', weight: '500' },
  h6: { size: '10px', weight: '600' },
  h7: { size: '9px', weight: '500' },
  h8: { size: '24px', weight: '500' },
  h9: { size: '24px', weight: '700' },
  p: { size: '10px', weight: '500' },
  title: { size: '18px', weight: '600' },
  subtitle: { size: '14px', weight: '600' },
  header: { size: '22px', weight: '600' },
  pageTitle: { size: '32px', weight: '700' }
}
